var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organizationDetails.payoutType === 'WISE')?_c('WiseForm'):(_vm.organizationDetails.payoutType === 'PAYPAL' || !_vm.organizationDetails.payoutType)?_c('PayPalVerify'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }